import React from 'react';
import Skeleton from 'components/Loading/Skeleton';

interface Props {
  rows?: number;
  columns?: number;
  height?: string;
}

export default function SkeletonTable({ rows = 10, columns = 5, height = '800px' }: Props) {
  return (
    <div
      className="overflow-auto rounded-lg border border-palette-border bg-palette-black-2"
      style={{ height }}
      role="status"
      aria-label="Loading table"
    >
      <table className="w-full">
        {/* Header row */}
        <thead className="sticky top-0 bg-palette-black-3">
          <tr>
            {[...Array(columns)].map((_, i) => (
              <th key={i} className="p-3">
                <Skeleton width="w-24" height="h-4" />
              </th>
            ))}
          </tr>
        </thead>

        {/* Data rows */}
        <tbody>
          {[...Array(rows)].map((_, rowIndex) => (
            <tr key={rowIndex} className="border-t border-palette-border">
              {[...Array(columns)].map((_, colIndex) => (
                <td key={colIndex} className="p-3">
                  <Skeleton
                    width={colIndex === 0 ? 'w-16' : colIndex === columns - 1 ? 'w-12' : 'w-20'}
                    height="h-4"
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
